export const SOCIAL_MEDIA_LINKS = [
  {
    key: "facebook",
    label: "Facebook",
    href: "https://www.facebook.com/venuemanagercrm1",
  },
  {
    key: "instagram",
    label: "Instagram",
    href: "https://www.instagram.com/venuemanagercrm/",
  },
  {
    key: "x",
    label: "X",
    href: "https://x.com/VenueManager1",
  },
  {
    key: "youtube",
    label: "YouTube",
    href: "https://www.youtube.com/@VenueManagerCRM",
  },
];
